<mcg-window #formCuadricula [width]="450" [height]="250" [canResize]="false"  [title]="translate('Cuadricula')"
  [shouldOpen]="true" [actions]="actions" (actionButtonClicked)="actionButtonClicked($event)" (windowClosed)="onCloseForm()"
>
  <div class="flex-column full-width">
    <div class="full-width flex-row gap-2 space-between">
      <div class="flex-column">
        <div style="float:left; clear:both;">
          {{translate('Nombre')}}
        </div>
        <jqxInput [width]="235" [height]="25" [(ngModel)]="cuadricula.nombre">
        </jqxInput>
      </div>

      <div class="flex-column">
        <div style="float:left; clear:both;">
          {{translate('Lado_celda')}}
        </div>
        <jqxNumberInput [width]="72" [height]="25" [(ngModel)]="cuadricula.lado"
          (ngModelChange)="changeLado()"
          [min]="lado_minimo_cuadricula" [inputMode]="'simple'" [decimalDigits]="0"
        >
        </jqxNumberInput>
      </div>
    </div>

    <div class="flex-row gap-2">
      <div class="flex-column full-width">
        <div style="float:left; clear:both;">
          {{translate('Descripcion')}}
        </div>
        <jqxInput [width]="'100%'" [height]="25" [(ngModel)]="cuadricula.descripcion">
        </jqxInput>
      </div>
    </div>

    <div class="flex-row gap-2">
      <div class="flex-column full-width">
        <div style="float:left; clear:both;">
          {{translate('Zona_cartografica')}}
        </div>
        <div>
          <jqxDropDownList #ddZonas [width]="'100%'" [height]="25" [selectedIndex]="0"
            (onSelect)="onChangeZona($event.args.item.value, $event.args.item.label)" [searchMode]="'containsignorecase'"
            [filterable]="true" [filterPlaceHolder]="'Buscar...'">
          </jqxDropDownList>
        </div>
      </div>
    </div>

    <div class="flex-row gap-2">
      <div class="flex-row align-center mt-1">
        <input [ngModel]="cuadricula?.numeracionVisible"
          (ngModelChange)="cuadricula.numeracionVisible = $event" type="checkbox"/>
        <label>{{ translate('Numeracion_visible') }}</label>
      </div>
    </div>
  </div>
  </mcg-window>
